import { useContext } from 'react';
import { ModalsContext } from 'new/routes/ModalsContext';

export function useModals() {
  return useContext(ModalsContext);
}
